<template>
  <div class="report">
    <div v-for="(items,index) in list" class="PageNext">
      <div class="title">{{name}}</div>
      <div class="head"><div>医疗卫⽣机构名称: {{items.hospital}}</div><div>医院编号: {{items.code}}</div></div>
      <div class="head"><div>医疗废物处置单位: {{factory}}</div><div>时间: {{items.time}}</div></div>
      <img class="stamp" src="static/stmap.png" />
      <table>
        <tr>
          <th rowspan="2">日期</th>
          <th colspan="2">感染性废物</th>
          <th colspan="2">损伤性废物</th>
          <th rowspan="2">医疗卫⽣机构交接⼈员签名</th>
          <th rowspan="2">废物运送⼈员签名</th>
          <th rowspan="2">交接时间</th>
        </tr>
        <tr>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
          <th>体积 (箱)</th>
          <th>重量 (kg)</th>
        </tr>
        <tr v-for="item in items.list">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td><img :src="host+item[5]" v-if="item[5].length>4"> </td>
          <td><img :src="host+item[6]" v-if="item[6].length>4"> </td>
          <td>{{item[7]}}</td>
        </tr>
      </table>
      <div class="head" ><div>制表人: {{tabulator}}</div><div>审核人: {{reviewer}}</div></div>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Dangerous",
    data(){
      return {
        name:"危险废物转移联单",


        factory:"",
        host:"",
        tabulator:"",
        reviewer:"",
        list:[]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
        // this.request("http://mw.mjhero.cn:9588/upload?key="+this.$route.query.key,(res)=>{
         this.list=res.list;
         this.name=res.name;
         this.factory=res.factory;
         this.host=res.host;
         this.reviewer=res.reviewer;
         this.tabulator=res.tabulator;
        })
      },
    },
    mounted(){


    },
    created(){
      this.init()
    }
  }

</script>
<style media=print>
  .Noprint{display:none;}
  .PageNext{page-break-after: always;}
</style>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 18px;}
  table{
    border-collapse: collapse;
    width: 100%;
  }
  table td{border: 1px solid #000;font-size: 14px;height:22px;}
  table th{border: 1px solid #000;font-size: 14px;height:22px;}
  .head{height:22px;line-height:22px;font-size: 16px}
  .head>div{display: inline-block;width: 75%;text-align: left;}
  .head>div:last-child{text-align: right !important; width: 25%}
  img{width:66px;height: 22px}
  .stamp{position: fixed;top: -100px;display: none}
  @media print{
    .stamp{position: fixed;top: 15px;left:150px;width:200px;height: 200px;display: block !important;}
  }
</style>



// WEBPACK FOOTER //
// src/view/report/dangerous.vue